/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { pacienteProgramasControllerObtenerProgramasPaciente } from '../fn/paciente-programas/paciente-programas-controller-obtener-programas-paciente';
import { PacienteProgramasControllerObtenerProgramasPaciente$Params } from '../fn/paciente-programas/paciente-programas-controller-obtener-programas-paciente';
import { ProgramaModelDto } from '../models/programa-model-dto';

@Injectable({ providedIn: 'root' })
export class PacienteProgramasService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `pacienteProgramasControllerObtenerProgramasPaciente()` */
  static readonly PacienteProgramasControllerObtenerProgramasPacientePath = '/api/programas/programas-paciente';

  /**
   * Obtener programas asignados al paciente autenticado.
   *
   * Devuelve la lista de programas asignados al paciente identificado autenticado
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pacienteProgramasControllerObtenerProgramasPaciente()` instead.
   *
   * This method doesn't expect any request body.
   */
  pacienteProgramasControllerObtenerProgramasPaciente$Response(params?: PacienteProgramasControllerObtenerProgramasPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProgramaModelDto>>> {
    return pacienteProgramasControllerObtenerProgramasPaciente(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener programas asignados al paciente autenticado.
   *
   * Devuelve la lista de programas asignados al paciente identificado autenticado
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pacienteProgramasControllerObtenerProgramasPaciente$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pacienteProgramasControllerObtenerProgramasPaciente(params?: PacienteProgramasControllerObtenerProgramasPaciente$Params, context?: HttpContext): Observable<Array<ProgramaModelDto>> {
    return this.pacienteProgramasControllerObtenerProgramasPaciente$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProgramaModelDto>>): Array<ProgramaModelDto> => r.body)
    );
  }

}
